// extracted by mini-css-extract-plugin
export var links = "Footer-module--links--LlgcH";
export var logo = "Footer-module--logo--Lu+fA";